// Polyfill process para dependencias que lo usan en browser (CRA no define process global).
// En bundle, process.env.NODE_ENV es sustituido por DefinePlugin de webpack.
window.process = window.process || {
  env: { NODE_ENV: process.env.NODE_ENV || 'development' },
};
